import React from "react";
import { Link, useLocation } from "react-router-dom";
import MobileDrawer from "./MobileDrawer";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Projects", to: "/projects" },
  { label: "About", to: "/about" },
  { label: "Articles", to: "/articles" },
  { label: "Contact", to: "/contact" }
];

export default function NavBar() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  return (
    <header className="w-full fixed top-0 z-40 backdrop-blur-xl bg-bg/80 border-b border-border-subtle/60">
      <nav className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 focus-visible:outline-none focus-visible:shadow-focus rounded-pill px-2 py-1">
          <span className="font-mono text-sm text-primary tracking-[0.3em] uppercase">Enkae</span>
          <span className="hidden sm:inline font-mono text-xs text-text-subtle">
            — Security · Automation · UI
          </span>
        </Link>

        <div className="hidden sm:flex gap-3 items-center">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`relative font-mono text-sm px-2 py-1 transition focus-visible:outline-none focus-visible:shadow-focus rounded-pill ${
                isActive(link.to) ? "text-accent" : "text-text-muted hover:text-primary"
              }`}
            >
              {link.label}
              <span
                className={`absolute left-1/2 -bottom-1 h-0.5 w-6 -translate-x-1/2 rounded-full transition ${
                  isActive(link.to) ? "bg-accent" : "bg-transparent"
                }`}
              />
            </Link>
          ))}
        </div>

        <button
          aria-label="Toggle menu"
          aria-expanded={open}
          className="sm:hidden p-2 rounded-full border border-border-subtle text-primary hover:border-accent transition focus-visible:outline-none focus-visible:shadow-focus"
          onClick={() => setOpen(true)}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
      </nav>

      <MobileDrawer open={open} onClose={() => setOpen(false)} links={NAV_LINKS} activePath={location.pathname} />
    </header>
  );
}

